import { Box, Spinner, useToast } from '@chakra-ui/react'
import { TableBuild } from 'components/organisms'
import { useAuthContext } from 'contexts/auth'
import { motion } from 'framer-motion'
import { OperationTypes } from 'interfaces/Operations'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import ContractService from 'services/contracts'
import { generateFile } from 'utils/blob'
import formatter from 'utils/formatter'
import { statusOperation } from 'utils/reusableFunction'

interface Operation {
    dataCriacao: string
    mensagemRetorno: string
    numeroContrato: string
    tipoOperacao: OperationTypes
    usuario: string
}

export const ReasonRejection = ({
    dataCriacao,
    mensagemRetorno,
    numeroContrato,
    tipoOperacao,
    usuario
}: Operation) => {
    const [loadingFile, setLoadingFile] = useState<boolean>(false)
    const { isBackoffice } = useAuthContext()
    const toast = useToast()

    const table = {
        header: [
            {
                name: 'numeroContrato',
                text: 'Nº do Contrato',
                position: 0
            },
            {
                name: 'usuario',
                text: 'Usuário',
                position: 1
            },
            {
                name: 'tipoOperacao',
                text: 'Tipo da Operação',
                position: 2
            },
            {
                name: 'dataCriacao',
                text: 'Data Operação:',
                position: 3
            },
            {
                name: 'mensagemRetorno',
                text: 'Motivo',
                position: 4
            }
        ],
        body: [
            {
                dataCriacao: dataCriacao
                    ? formatter.dataWithHour(dataCriacao)
                    : '',
                mensagemRetorno: mensagemRetorno ?? '',
                numeroContrato: numeroContrato ?? '',
                tipoOperacao: tipoOperacao
                    ? (statusOperation(tipoOperacao) as string)
                    : '',
                usuario: usuario ?? ''
            }
        ],
        ...(isBackoffice
            ? {
                  action: [
                      {
                          type: 'DOWNLOAD'
                      }
                  ]
              }
            : {})
    }

    const handleAction = (action: string, indexRow: number | string) => {
        downloadFile('TXT')
    }

    const { id = '' } = useParams()

    const downloadFile = async (type: 'TXT') => {
        try {
            setLoadingFile(true)
            const response = await ContractService.generateTxtReasonReject(id)

            generateFile(type, response)

            toast({
                title: 'Arquivo gerado com sucesso!',
                description: `O arquivo ${type} foi gerado conforme os filtros selecionados. Verifique sua pasta de downloads para acessá-lo.`,
                position: 'bottom-left',
                status: 'success',
                isClosable: true
            })
        } catch (error) {
            toast({
                title: 'Sentimos muito!',
                description: 'Ocorreu um erro, tente novamente mais tarde.',
                position: 'bottom-left',
                status: 'error',
                isClosable: true
            })
        } finally {
            setLoadingFile(false)
        }
    }

    const Loading = () => {
        return (
            <Box
                as={motion.div}
                bg="white"
                borderTopRadius="8px"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                height="500px"
                display="flex"
                justifyContent="center"
                alignItems={'center'}
                position="relative"
            >
                <Spinner
                    size="xl"
                    speed="1s"
                    position="absolute"
                    top="calc(50% - 33px)"
                    left="calc(50% - 33px)"
                />
            </Box>
        )
    }

    if (loadingFile) return <Loading />

    return (
        <TableBuild
            header={table.header}
            body={table.body}
            action={table.action as any}
            onAction={handleAction}
        />
    )
}
